import React from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from 'reactstrap';
import { httpsCallable } from 'firebase/functions';
import { useToggle } from 'react-use';
import { toast } from 'react-toastify';

import { functions } from '../../firebase';
import TenantPage from '../TenantPage';
import useTenant from '../hooks/useTenant';
import EditButton from '../EditButton';
import ModelFormModal from '../modals/ModelFormModal';
import { settingsFields } from '../../shared/models/tenant';
import { fieldDisplayValue } from '../../shared/util';
import SettingsTabs from '../SettingsTabs';

export default function Settings (props) {
  return (
    <TenantPage>
      <PageContent {...props} />
    </TenantPage>
  );
};

function PageContent (props) {
  const { tenant, } = props;
  const activeTab = 'general';
  const [isLoading, toggleLoading] = useToggle(false);

  const onClickManageSubscription = async () => {
    toggleLoading(true);
    try {
      const createCustomerPortalSession = httpsCallable(functions, 'createCustomerPortalSession');
      const { data: { url } } = await createCustomerPortalSession();
      window.location.href = url;
    } catch (e) {
      console.error(e);
      toast.error('エラーが発生しました');
      toggleLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="px-4">
        <div className="card p-4">
          <SettingsTabs activeTab={activeTab} />
          <div className="mb-3 d-flex justify-content-start align-items-end gap-1">
            <EditButton
              itemRef={tenant.ref}
              FormModal={ModelFormModal}
              formProps={{
                title: '設定',
                fields: settingsFields(),
              }}
            />
          </div>
          <table className="table table-bordered">
            <tbody>
              {Object.entries(settingsFields()).map(([fieldName, fieldSettings]) => {
                const { label, initialValue } = fieldSettings;
                const value = tenant[fieldName] || initialValue;
                return (
                  <tr key={fieldName}>
                    <td style={{ minWidth: 150, }}>{label}</td>
                    <td style={{ minWidth: 150, }}>{fieldDisplayValue(tenant, fieldName, fieldSettings) || value || '-'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {tenant.stripeCustomerId && (
          <div className="card p-4 mt-3">
            <h6>プラン・お支払い</h6>
            <div className="d-flex align-items-center gap-3">
              <div>
                <span className="text-muted">ステータス: </span>
                <span className="fw-bold">
                  {({ trialing: 'トライアル中', active: '有効', past_due: '支払い遅延', canceled: '解約済み', unpaid: '未払い' })[tenant.subscriptionStatus] || tenant.subscriptionStatus || '-'}
                </span>
              </div>
              <Button color="primary" outline size="sm" onClick={onClickManageSubscription} disabled={isLoading}>
                {isLoading ? '処理中...' : 'プラン・お支払い管理'}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
